import React, { useMemo } from "react";

interface DrawerProps {
  position?: "left" | "right";
  isOpen: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
}

export const Drawer = ({ position, isOpen, children, onClose }: DrawerProps) => {
  const currentPosition = useMemo(() => {
    if (position === "right") {
      return isOpen ? "right-0" : "right-[-329px]";
    } else {
      return isOpen ? "left-0" : "left-[-329px]";
    }
  }, [isOpen, position]);

  const roundedStyle = useMemo(() => {
    return position === "right" ? "rounded-l-2xl" : "rounded-r-2xl";
  }, [position]);

  return (
    <>
      <div
        className={`fixed top-0 bottom-0 !m-0 ${roundedStyle} ${currentPosition} w-full max-w-[329px] z-[100] overflow-hidden bg-neutrals-white transition-all`}
      >
        {children}
      </div>
      <div className={`generic-overlay !m-0 ${isOpen ? "show" : "pointer-events-none"}`} onClick={onClose} />
    </>
  );
};
